/*
 * Service worker registration.
 *
 * The AngularJS app registered one; the React rewrite dropped the call, so
 * for a while the worker only ran for people who had visited the old site —
 * and that stale copy was doubling every request. Registering again both
 * restores offline access and replaces those copies with the current one,
 * whose activate handler deletes the caches they accumulated.
 *
 * Production only: in dev the caching just gets between you and your
 * changes.
 */
export function registerServiceWorker() {
	if (!import.meta.env.PROD) return;
	if (!('serviceWorker' in navigator)) return;

	/* After load, so registration never competes with the first paint. */
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/service-worker.js').catch(() => {
			/* Unsupported, blocked by policy, or served over plain http —
			 * none of which should surface to the person using the site. */
		});
	});
}
